export const CREATE_MANAGER = 'SAVE_MANAGER';
export const GET_MANAGER = 'GET_MANAGER';
export const SET_MANAGER = 'SET_MANAGER';
export const UPDATE_MANAGER = 'UPDATE_MANAGER';
